'use client'

import { useMemo } from 'react'
import { useInfiniteMasterClassStudioQuery } from '@/generated/graphql'
import StudioGrid from '@/Studio/StudioGrid'
import { Button } from '@/General/Button'
import { LoadingSpinner } from '@/General/LoadingSpinner'

export const StudioGridClient = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    isError,
    error,
  } = useInfiniteMasterClassStudioQuery(
    {
      take: 50,
      skip: 0,
    },
    {
      initialPageParam: { skip: 0 },
      getNextPageParam: (lastPage, allPages) => {
        const hasNext = lastPage?.streams?.pageInfo?.hasNextPage
        if (!hasNext) return undefined

        // Calculate total items loaded across all pages
        const totalLoaded = allPages.reduce(
          (total, page) => total + (page?.streams?.items?.length || 0),
          0
        )

        return { skip: totalLoaded }
      },
      getPreviousPageParam: () => undefined,
      enabled: true,
    }
  )

  // Flatten all pages into a single array of lessons
  const allLessons = useMemo(() => {
    return (
      data?.pages
        ?.flatMap(page => page?.streams?.items || [])
        .filter(Boolean) || []
    )
  }, [data?.pages])

  if (isError) {
    return (
      <div className="flex justify-center py-8">
        <p className="text-red-600">
          Error loading Studio content:{' '}
          {error instanceof Error ? error.message : 'Unknown error'}
        </p>
      </div>
    )
  }

  return (
    <>
      <StudioGrid lessons={allLessons} />

      {(isFetching || isFetchingNextPage) && (
        <div className="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      )}

      {hasNextPage && !isFetchingNextPage && (
        <div className="flex justify-center py-8">
          <Button onClick={() => fetchNextPage()} color="blue" outline>
            Load more
          </Button>
        </div>
      )}
    </>
  )
}
